module.exports = __webpack_public_path__ + "static/img/active7.ba6c8a99.png";